// apps/client/src/audio/mood.ts — 05:00 morning (glockenspiel) · 11:00 midday (marimba) · 17:00 golden (flute) · 19:30 dusk (music box)
// The same tuning.time.presetStarts schedule the lighting reads (contract change 16), so music and light change together.
import { tuning } from '@whiskerton/content';

export function moodAt(minuteOfDay: number): 0 | 1 | 2 | 3 {
  const s = tuning.time.presetStarts, m = ((minuteOfDay % 1440) + 1440) % 1440;
  if (m >= s.morning && m < s.midday) return 0;
  if (m >= s.midday && m < s.golden) return 1;
  if (m >= s.golden && m < s.dusk) return 2;
  return 3;
}
